export default __webpack_public_path__ + "672a8bd.png";